let config
if (process.env.NODE_ENV === 'production') {
  config = {
    apiUrl: 'https://api.expodogs.es/api', // 'http://api.test/api', //
    timeoutDuration: 30000,
    someOtherProps: 'xyz',
    login: {
      username: null,
      password: null
    }
  }
} else {
  config = {
    apiUrl: 'http://api.test/api', // 'https://ws.eisi.cc/expodogs/api', //

    login: {
      username: null,
      password: null
    },
    timeoutDuration: 1000,
    someOtherProps: 'abc'
  }
}
/*
let vuetables2 = {
  options: {
    texts: {
      count: "Mostrando {from} al {to} de {count} registros|{count} registros|Un registro",
      first: 'Primero',
      last: 'Last',
      filter: "Filtar:",
      filterPlaceholder: "Buscar",
      limit: "Registros:",
      page: "Página:",
      noResults: "No hay resultados",
      filterBy: "Filter by {column}",
      loading: 'Cargan...',
      defaultOption: 'Seleccion {column}',
      columns: 'Columnas'
    }
  }
}

config.push(vuetables2);
*/

export {
  config
}
